import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class NotFoundErrorService {

  constructor() { }

  /**
   * Not found error
   * @param errorCode 
   * @returns error message 
   */
  notFoundError(errorCode): string {
    let message = "There is a conflict.";

    let errors = Object.keys(NotFoundError).map(key => NotFoundError[key]);

    if (errors.some(e => e[0] === errorCode)) {
      let err = errors.find(e => e[0] === errorCode);
      message = err[1];
    }

    return message;
  }

}
/**
 * @ignore
 */
export const NotFoundError = {
  ERROR_NOT_FOUND: {},
  ERROR_NOT_FOUND_USER_ID: {},
  ERROR_NOT_FOUND_CUSTOMER_ID: {},
  ERROR_NOT_FOUND_CLIENT_ID: {},
  ERROR_NOT_FOUND_BACKGROUND_ID: {},
  ERROR_NOT_FOUND_PRESET_ID: {},
  ERROR_NOT_FOUND_COLLAGE_ID: {},
  ERROR_NOT_FOUND_COLLAGE_PRESET_ASSIGNMENT: {},
  ERROR_NOT_FOUND_CLIENT_WEBHOOK_ID: {},
  ERROR_NOT_FOUND_FILE_ID: {},
  ERROR_NOT_FOUND_BACKGROUND_FILE_ID: {},
  ERROR_NOT_FOUND_VEHICLE_ID: {},
  ERROR_NOT_FOUND_VEHICLE_FILE_ID: {},
  ERROR_NOT_FOUND_TARGET_ID: {},
  ERROR_NOT_FOUND_PRESET_TARGET_ID: {},
  ERROR_NOT_FOUND_TARGET_FILE_TYPE: {},
  ERROR_NOT_FOUND_PRESET_TARGET_FILE_TYPE: {},
  ERROR_NOT_FOUND_FRAME_ID: {},
  ERROR_NOT_FOUND_VEHICLE_IMAGE_ID: {},
  ERROR_NOT_FOUND_USER_EMAIL: {},
  ERROR_NOT_FOUND_DMS_ID: {},
  ERROR_NOT_FOUND_IMAGE_ID: {},
  ERROR_NOT_FOUND_VEHICLE_DETAILS: {},
  ERROR_NOT_FOUND_ROUTE_NOT_MATCHED: {},
  ERROR_NOT_FOUND_USER_DMS: {},
  ERROR_NOT_FOUND_BACKGROUND_FLOOR_ID: {},
  ERROR_NOT_FOUND_BACKGROUND_WALL_ID: {},
  ERROR_NOT_FOUND_BACKGROUND_OFFER_ID: {},
  ERROR_NOT_FOUND_FEATURE_ID: {},
  ERROR_NOT_FOUND_FEATURES: {},
  ERROR_NOT_FOUND_CROP_IMAGE_ID: {},
  ERROR_NOT_FOUND_CLIENT_LICENSE_PLATE_ID: {},
  ERROR_NOT_FOUND_USER_SETTINGS_GROUP: {},
  ERROR_NOT_FOUND_CLIENT_SETTINGS_GROUP: {}
}


NotFoundError.ERROR_NOT_FOUND = [4040000, 'Not Found'];
NotFoundError.ERROR_NOT_FOUND_USER_ID = [4040001, 'User not found'];
NotFoundError.ERROR_NOT_FOUND_CUSTOMER_ID = [4040002, 'Customer not found'];
NotFoundError.ERROR_NOT_FOUND_CLIENT_ID = [4040003, 'Client not found'];
NotFoundError.ERROR_NOT_FOUND_PRESET_ID = [4040005, 'Preset not found'];
NotFoundError.ERROR_NOT_FOUND_COLLAGE_ID = [4040006, 'Collage not found'];
NotFoundError.ERROR_NOT_FOUND_COLLAGE_PRESET_ASSIGNMENT = [
	4040007,
	'Collage is not assigned to the preset',
];
NotFoundError.ERROR_NOT_FOUND_CLIENT_WEBHOOK_ID = [4040010, 'Client Webhook not found'];
NotFoundError.ERROR_NOT_FOUND_FILE_ID = [4040011, 'File not found'];
NotFoundError.ERROR_NOT_FOUND_BACKGROUND_FILE_ID = [4040012, 'Background File not found'];
NotFoundError.ERROR_NOT_FOUND_BACKGROUND_ID = [4040013, 'Background not found'];
NotFoundError.ERROR_NOT_FOUND_VEHICLE_ID = [4040014, 'Vehicle not found'];
NotFoundError.ERROR_NOT_FOUND_VEHICLE_FILE_ID = [4040015, 'Vehicle File not found'];
NotFoundError.ERROR_NOT_FOUND_TARGET_ID = [4040016, 'Target not found'];
NotFoundError.ERROR_NOT_FOUND_PRESET_TARGET_ID = [4040017, 'Preset Target not found'];
NotFoundError.ERROR_NOT_FOUND_TARGET_FILE_TYPE = [
	4040018,
	'Target does not have file with type :type',
];
NotFoundError.ERROR_NOT_FOUND_PRESET_TARGET_FILE_TYPE = [
	4040019,
	'Preset Target with id :presetTargetId does not have file with type :type',
];
NotFoundError.ERROR_NOT_FOUND_FRAME_ID = [4040020, 'Frame not found'];
NotFoundError.ERROR_NOT_FOUND_VEHICLE_IMAGE_ID = [
	4040021,
	'Image with id :imageId not found for the vehicle with id :vehicleId',
];
NotFoundError.ERROR_NOT_FOUND_USER_EMAIL = [4040022, 'User with email :email not found'];
NotFoundError.ERROR_NOT_FOUND_DMS_ID = [4040023, 'DMS with id :dmsId not found'];
NotFoundError.ERROR_NOT_FOUND_IMAGE_ID = [4040024, 'Image with id :imageId not found'];
NotFoundError.ERROR_NOT_FOUND_VEHICLE_DETAILS = [4040025, 'Details for vehicle with id :vehicleId not found'];
NotFoundError.ERROR_NOT_FOUND_ROUTE_NOT_MATCHED = [4040026, 'Route not matched'];
NotFoundError.ERROR_NOT_FOUND_USER_DMS = [4040029, 'DMS with id :dmsId not found for user with id :userId'];
NotFoundError.ERROR_NOT_FOUND_BACKGROUND_FLOOR_ID = [4040030, 'Background Floor not found'];
NotFoundError.ERROR_NOT_FOUND_BACKGROUND_WALL_ID = [4040031, 'Background Wall not found'];
NotFoundError.ERROR_NOT_FOUND_BACKGROUND_OFFER_ID = [4040032, 'Background Offer not found'];
NotFoundError.ERROR_NOT_FOUND_FEATURE_ID = [4040033, 'Feature not found'];
NotFoundError.ERROR_NOT_FOUND_FEATURES = [4040035, 'Features not found'];
NotFoundError.ERROR_NOT_FOUND_CROP_IMAGE_ID = [4040036, 'Crop Image not found'];
NotFoundError.ERROR_NOT_FOUND_CLIENT_LICENSE_PLATE_ID = [
	4040037,
	'Client License Plate not found',
];
NotFoundError.ERROR_NOT_FOUND_USER_SETTINGS_GROUP = [
	4040038,
	'User Settings Group not found',
];
NotFoundError.ERROR_NOT_FOUND_CLIENT_SETTINGS_GROUP = [
	4040039,
	'Client Settings Group not found',
];